<template>
  <v-bottom-navigation
    :model-value="activeNavigation"
    grow
    height="72"
    bg-color="var(--c-dark-blue)"
    base-color="rgba(255, 255, 255, 0.78)"
    color="var(--c-white)"
    elevation="8">
    <v-defaults-provider :defaults="buttonDefaults">
      <v-btn
        value="work-schedule"
        @click="navigateTo('work-schedule')">
        <v-icon icon="mdi-home-clock" />
        <span>Work Schedule</span>
      </v-btn>
      <v-btn
        value="bid-entry"
        @click="navigateTo('bid-entry')">
        <v-icon icon="mdi-account-hard-hat" />
        <span>Bidding</span>
      </v-btn>
      <v-btn
        value="feedback"
        @click="showUserFeedback = true">
        <v-icon icon="mdi-message-text-outline" />
        <span>Feedback</span>
      </v-btn>
    </v-defaults-provider>
  </v-bottom-navigation>
  <UserFeedback v-model="showUserFeedback" />
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserFeedback from "@views/user/bid-entry/components/UserFeedback.vue";

const showUserFeedback = ref(false);
const route = useRoute();
const router = useRouter();
const activeNavigation = computed(() => (showUserFeedback.value ? "feedback" : route.name));
const buttonDefaults = {
  VBtn: {
    variant: "plain",
    class: "pa-1 font-weight-medium opacity-100",
    ripple: false,
  },
};

function navigateTo(routeName: "work-schedule" | "bid-entry") {
  showUserFeedback.value = false;
  router.push({ name: routeName });
}
</script>